export default { sha: '8e7043689c8058d4e072577245878c5fa5ac8be0', buildNumber: 'undefined' }
